module.exports = __webpack_public_path__ + "img/farm-shots-logo.0ef139fd.svg";